import { useEffect, useState } from 'react'
import { Progress } from '../globalTypes'

export const useDidMountWithProgress = (cb: () => (() => void) | void, progress: Progress) => {
  const [isMounted, setMounted] = useState(false)

  useEffect(() => {
    if (!isMounted) {
      cb()
      // this timeout added just for compatibility with useAction hook.
      // see useAction hook for details.
      setTimeout(() => setMounted(true), 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted])

  return isMounted ? progress : Progress.WORK
}
